import { cn } from '../../lib/utils';
import { Badge } from '../ui/badge';
import { Truck, Store, ExternalLink, Check } from 'lucide-react';

export const StorePrice = ({ 
  store, 
  price, 
  available = true,
  deliveryAvailable = false,
  curbsideAvailable = true,
  storeUrl,
  isLowest = false 
}) => {
  const storeColors = {
    trader_joes: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
    whole_foods: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
    sprouts: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  };

  const storeNames = {
    trader_joes: "Trader Joe's",
    whole_foods: "Whole Foods",
    sprouts: "Sprouts",
  };

  return (
    <div 
      className={cn(
        "flex items-center justify-between p-3 rounded-xl border transition-all",
        isLowest 
          ? "border-primary bg-primary/5" 
          : "border-border bg-card",
        !available && "opacity-50"
      )}
      data-testid={`store-price-${store}`}
    >
      <div className="flex items-center gap-3">
        <Badge className={cn("text-xs", storeColors[store])}>
          {storeNames[store] || store}
        </Badge>
        
        <div className="flex items-center gap-2">
          {deliveryAvailable && (
            <span 
              className="flex items-center gap-1 text-xs text-muted-foreground"
              title="Delivery available"
            >
              <Truck className="h-3 w-3" aria-hidden="true" />
              <span className="sr-only">Delivery available</span>
            </span>
          )}
          {curbsideAvailable && (
            <span 
              className="flex items-center gap-1 text-xs text-muted-foreground"
              title="Curbside pickup available"
            >
              <Store className="h-3 w-3" aria-hidden="true" />
              <span className="sr-only">Curbside pickup available</span>
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className={cn(
          "font-semibold",
          isLowest ? "text-primary" : "text-foreground"
        )}>
          ${price.toFixed(2)}
        </span>
        
        {isLowest && (
          <Badge variant="outline" className="text-xs border-primary text-primary">
            <Check className="h-3 w-3 mr-1" aria-hidden="true" />
            Best
          </Badge>
        )}

        {storeUrl && available && (
          <a
            href={storeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="p-1.5 rounded-lg bg-muted hover:bg-muted/80 transition-colors"
            aria-label={`Order from ${storeNames[store] || store}`}
            data-testid={`order-link-${store}`}
          >
            <ExternalLink className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
          </a>
        )}
      </div>
    </div>
  );
};
